function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 11.5C10.9 11.5 10 11.15 9.3 10.45C8.6 9.75 8.25 8.85 8.25 7.75C8.25 6.65 8.6 5.75 9.3 5.05C10 4.35 10.9 4 12 4C13.1 4 14 4.35 14.7 5.05C15.4 5.75 15.75 6.65 15.75 7.75C15.75 8.85 15.4 9.75 14.7 10.45C14 11.15 13.1 11.5 12 11.5ZM18.5 19.525H5.5C5.08333 19.525 4.72917 19.3792 4.4375 19.0875C4.14583 18.7958 4 18.4417 4 18.025V17.175C4 16.5417 4.15833 16 4.475 15.55C4.79167 15.1 5.2 14.7583 5.7 14.525C6.81667 14.025 7.8875 13.65 8.9125 13.4C9.9375 13.15 10.9667 13.025 12 13.025C13.0333 13.025 14.0583 13.1542 15.075 13.4125C16.0917 13.6708 17.1583 14.0417 18.275 14.525C18.7917 14.7583 19.2083 15.1 19.525 15.55C19.8417 16 20 16.5417 20 17.175V18.025C20 18.4417 19.8542 18.7958 19.5625 19.0875C19.2708 19.3792 18.9167 19.525 18.5 19.525Z",
  fill: "url(#paint0_linear_2811_459)"
});
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_2811_459",
  x1: 4,
  y1: 3.52539,
  x2: 12,
  y2: 19.525,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#753CBE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3CC0C3"
})));
function SvgProfileActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileActive);
export default __webpack_public_path__ + "static/media/profile_active.34164ec6ecc2bceed7588d0335b5c02e.svg";
export { ForwardRef as ReactComponent };